<form class="form" [formGroup]="form">
    <div class="form-wrapper">
        <div class="form-row">
            <h4 class="display-6">{{ 'giftOptions.labels.fromTo' | translateSafe }}</h4>
            <div class="row-wrapper">
                <app-input
                    [control]="form.controls['to']"
                    [label]="'forms.labels.cardTo' | translateSafe"
                    [placeholder]="'forms.placeholders.cardTo' | translateSafe"
                    [maxlength]="25"
                    [helpText]="'giftOptions.help.to' | translateSafe"
                    [autocomplete]="'name'"
                    marginBottom="small"
                ></app-input>

                <app-input
                    [control]="form.controls['from']"
                    [label]="'forms.labels.cardFrom' | translateSafe"
                    [placeholder]="'forms.placeholders.cardFrom' | translateSafe"
                    [maxlength]="25"
                    [helpText]="'giftOptions.help.from' | translateSafe"
                    [autocomplete]="'name'"
                    marginBottom="small"
                ></app-input>
            </div>
        </div>

        <div class="form-row">
            <h4 class="display-6">{{ 'giftOptions.labels.message' | translateSafe: { limit: maxNumOfChars } }}</h4>

            <app-input-textarea
                [control]="form.controls['lines']"
                [label]="'forms.labels.cardMessage' | translateSafe"
                [placeholder]="'forms.placeholders.cardMessage' | translateSafe"
                [maxlength]="maxNumOfChars"
                [showCounter]="true"
                [allowNewLines]="false"
                [helpText]="'giftOptions.help.message' | translateSafe"
            ></app-input-textarea>
        </div>
    </div>
</form>
